import type { AuthSession } from '../features/auth/types'
import { ClientTypes, UserTypes } from '../types/authorization'

const ZERO_GUID = '00000000-0000-0000-0000-000000000000'

function isZeroGuidUser(session: AuthSession | null) {
  return session?.currentUserId === ZERO_GUID
}

function resolveLegacyStyleRoute(session: AuthSession | null) {
  if (!session) return '/login'

  const userType = isZeroGuidUser(session) ? UserTypes.UnregisteredUser : session.currentUserTypeId
  const clientType = session.currentClientTypeId
  const clientId = session.currentClientId
  const userId = session.currentUserId

  switch (userType) {
    case UserTypes.Owner:
    case UserTypes.Admin:
      return '/clients'
    case UserTypes.ClientAdmin:
      if (clientType === ClientTypes.Advisor) return '/clients'
      return clientId ? `/clients/${clientId}` : '/clients'
    case UserTypes.ClientUser:
      if (clientType === ClientTypes.Advisor) return '/clients'
      return userId ? `/users/${userId}` : '/users'
    case UserTypes.User:
      return userId ? `/users/${userId}` : '/users'
    case UserTypes.UnregisteredUser:
      return '/signupwithxeroform'
    default:
      return '/clients'
  }
}

// React route-compatible variant of the legacy rules.
export function resolvePostLoginRoute(session: AuthSession | null) {
  const legacyRoute = resolveLegacyStyleRoute(session)

  // React app currently has `/users` but not `/users/:id`.
  if (legacyRoute.startsWith('/users/')) return '/users'
  // React app currently has no `/signupwithxeroform` page.
  if (legacyRoute === '/signupwithxeroform') return '/clients'

  return legacyRoute
}

